module.exports = __webpack_public_path__ + "static/media/sso-saml.0d72cc17.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/sso-saml.png
// module id = 13904
// module chunks = 0